module.exports = __webpack_public_path__ + "img/logo_4.28f78af4.jpg";